import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchVersions } from '../reducers/version';
import { Box, BoxPart } from 'components/box';

import type { StateVersion } from 'types';

type StateProps = {
  version: StateVersion
};

type Props = StateProps & {
  dispatch: any
};

class HealthInfo extends Component<Props> {
  componentDidMount() {
    this.props.dispatch(fetchVersions());
  }

  render() {
    const { version } = this.props;
    return (
      <Box bordered>
        <BoxPart>
          <div>
            Frontend version: <span data-qa="fe-version">{version.frontend}</span>
          </div>
          <div>
            Backend version: <span data-qa="be-version">{version.backend}</span>
          </div>
          <div>
            API version: <span>{version.backendSearch}</span>
          </div>
        </BoxPart>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  return {
    version: state.version
  };
}

export default connect(mapStateToProps)(HealthInfo);
